import * as React from 'react';
import Modal from '../../common/modal/modal';

interface IPromoCodeConflictProps {
    promoErrorMessage: string;
    promoCode: string;
    modalCancelButtonText: string;
    emptyCartButtonText: string;

    onCancelPromoClick: () => void;
    onEmptyCartClick: (string) => void;

}

class PromoCodeConflict extends React.PureComponent<IPromoCodeConflictProps, any>{
    render() {
        return (
            <Modal title="Cart Conflict"
                message={this.props.promoErrorMessage}
                isError={true}
                cancelFunction={this._onCancelPromoCodeClick.bind(this)}
                cancelString={this.props.modalCancelButtonText}
                closeFunction={this._onCancelPromoCodeClick.bind(this)}
                confirmFunction={() => this.props.onEmptyCartClick(this.props.promoCode)}
                confirmString={this.props.emptyCartButtonText} modalKey="promo code conflict" />
        );
    }

    _onPromoCodeInputChange(evt) {
        this.setState({
            promoCode: (evt.target as any).value
        });
    }

    _onCancelPromoCodeClick() {
        this.setState({
            promoCode: ""
        });
        this.props.onCancelPromoClick();
    }
}

export default PromoCodeConflict;